import "./charts.scss"

function Charts() {

  return (
    <div className="chart">
      Chart
    </div>

  )
}

export default Charts